import { createContext } from 'react';

/**
 * Told once a saved canvas's own content has shown, or has said it cannot: a saved App when its runtime
 * frame first paints or refuses. The canvas loads its secondary reads (the Share chip's audience) after
 * that, so they never compete with the App's own opening. Null outside a saved canvas.
 */
export const CanvasSettledContext = createContext<(() => void) | null>(null);
